import formatHeadings from './formatHeadings';
import themeEditor from './themeEditor';

export default () => {
  formatHeadings();
  themeEditor();
};